import { useState } from "react";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

export default function BmiCalculator() {
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [bmi, setBmi] = useState(null);
  const [category, setCategory] = useState("");

  const calculateBMI = () => {
    if (!height || !weight) return;

    const h = height / 100; // convert cm to meter
    const bmiValue = weight / (h * h);
    setBmi(bmiValue.toFixed(2));

    if (bmiValue < 18.5) setCategory("Underweight");
    else if (bmiValue < 24.9) setCategory("Normal");
    else if (bmiValue < 29.9) setCategory("Overweight");
    else setCategory("Obese");
  };

  return (
    <>
      <Helmet>
        <title>BMI Calculator Online - Calculate Your Body Mass Index Instantly</title>
        <meta name="description" content="Use our free online BMI Calculator to check your Body Mass Index using your height and weight. Instantly know if you're underweight, normal, overweight, or obese." />
        <meta name="keywords" content="bmi calculator, body mass index calculator, calculate bmi online, weight and height calculator, bmi chart" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/bmi-calculator" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>BMI Calculator</h2>
          <p>Enter your height (in cm) and weight (in kg) to find your BMI and category.</p>

          <div className="mb-3">
            <input
              type="number"
              className="form-control"
              placeholder="Height in cm"
              value={height}
              onChange={(e) => setHeight(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <input
              type="number"
              className="form-control"
              placeholder="Weight in kg"
              value={weight}
              onChange={(e) => setWeight(e.target.value)}
            />
          </div>

          <button className="btn btn-primary" onClick={calculateBMI}>
            Calculate BMI
          </button>

          {bmi && (
            <div className="alert alert-info mt-4">
              Your BMI is <strong>{bmi}</strong> — <strong>{category}</strong>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
